import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import image1 from '../../images/6D5A0194 A.jpg'
import image2 from '../../images/6D5A0240.jpg'

function AboutThree() {
  return (
    <Box sx={{ flexGrow: 1, padding: "20px", marginBottom:'30px' }}>
      <hr />
      <Grid container spacing={2}>

        <Grid item xs={12} md={6}>
          <Box sx={{ padding: "20px" }}>
            <Typography
              variant="overline"
              sx={{
                color: "#7b7b7b",
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              {/* A Short History of the Hotel */}
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                marginTop: "10px",
                marginBottom: "20px",
                fontFamily: "Georgia, serif",
              }}
            >
              Our Mission
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#555",
                marginBottom: "20px",
                lineHeight: 1.8,
              }}
            >
              At Unseen Knuckles, our mission is simple: to provide unforgettable experiences immersed in the wonders of nature.
              Nestled in the heart of the Knuckles Mountain Range, our boutique retreat blends rustic charm with modern comforts. Surrounded by majestic peaks, our intimate cottages offer a luxurious yet cozy haven for relaxation and exploration.

            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#555",
                lineHeight: 1.8,
              }}
            >
             
             Whether you’re seeking a romantic getaway, a peaceful retreat, or an adventurous escape, our warm hospitality and personalized approach promise a stay that is as unique as the landscape itself. Let Unseen Knuckles be your gateway to tranquility and adventure, where every moment is designed to leave you with cherished memories.

            </Typography>
          </Box>
        </Grid>


        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              position: "relative",
              marginTop: {sm:'30px', md:'80px' , lg: '60px' }

            }}
          >

             <Box
              component="img"
              src={image1} // Replace with the pool image URL or local path
              alt="Pool and palm trees"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "80%",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                
                
              }}
            />
            <Box
              component="img"
              src={image2} // Replace with the night image URL or local path
              alt="Night path"
              sx={{
                width: "60%",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                backgroundColor: "rgb(0,0,0,1)",
                zIndex: 2,

              }}
            />
           
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AboutThree;
